import BumpGroupsFormContainer from './BumpGroupsFormContainer';

export default BumpGroupsFormContainer;
